(function () {

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire70da"];
var parcelRegister = parcelRequire.register;
parcelRegister("5ONDf", function(module, exports) {

var $jCbkX = parcelRequire("jCbkX");
$parcel$exportWildcard(module.exports, $jCbkX);

});
parcelRegister("jCbkX", function(module, exports) {

$parcel$export(module.exports, "W3mModal", function () { return $e47a5c346ba22db5$export$8f54aa55129a8184; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $j06k0 = parcelRequire("j06k0");

var $ohfOJ = parcelRequire("ohfOJ");

var $eha6O = parcelRequire("eha6O");

var $cwWZ7 = parcelRequire("cwWZ7");

var $grHtr = parcelRequire("grHtr");

var $4A6TP = parcelRequire("4A6TP");

var $kAqXG = parcelRequire("kAqXG");

var $hEpgx = parcelRequire("hEpgx");
function $e47a5c346ba22db5$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n          <wui-flex @click=",
        ' data-testid="w3m-modal-overlay">\n            <wui-card\n              shake="',
        '"\n              role="alertdialog"\n              aria-modal="true"\n              tabindex="0"\n              data-testid="w3m-modal-card"\n            >\n              <w3m-header></w3m-header>\n              <w3m-router></w3m-router>\n              <w3m-snackbar></w3m-snackbar>\n            </wui-card>\n          </wui-flex>\n          <w3m-tooltip></w3m-tooltip>\n        '
    ]);
    $e47a5c346ba22db5$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $e47a5c346ba22db5$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $e47a5c346ba22db5$var$SCROLL_LOCK = "scroll-lock";


var $e47a5c346ba22db5$export$8f54aa55129a8184 = /*#__PURE__*/ function(LitElement) {
    "use strict";
    (0, $dcsZi._)(W3mModal, LitElement);
    var _super = (0, $ohfOJ._)(W3mModal);
    function W3mModal() {
        var _this_unsubscribe;
        (0, $4GJKx._)(this, W3mModal);
        var _this;
        _this = _super.call(this);
        _this.unsubscribe = [];
        _this.abortController = undefined;
        _this.open = (0, $cwWZ7.ModalController).state.open;
        _this.caipAddress = (0, $cwWZ7.AccountController).state.caipAddress;
        _this.isSiweEnabled = (0, $cwWZ7.OptionsController).state.isSiweEnabled;
        _this.connected = (0, $cwWZ7.AccountController).state.isConnected;
        _this.loading = (0, $cwWZ7.ModalController).state.loading;
        _this.shake = (0, $cwWZ7.ModalController).state.shake;
        _this.initializeTheming();
        (0, $cwWZ7.ApiController).prefetch();
        (_this_unsubscribe = _this.unsubscribe).push.apply(_this_unsubscribe, [
            (0, $cwWZ7.ModalController).subscribeKey("open", function(val) {
                return val ? _this.onOpen() : _this.onClose();
            }),
            (0, $cwWZ7.ModalController).subscribeKey("shake", function(val) {
                return _this.shake = val;
            }),
            (0, $cwWZ7.ModalController).subscribeKey("loading", function(val) {
                _this.loading = val;
                _this.onNewAddress((0, $cwWZ7.AccountController).state.caipAddress);
            }),
            (0, $cwWZ7.AccountController).subscribeKey("isConnected", function(val) {
                return _this.connected = val;
            }),
            (0, $cwWZ7.AccountController).subscribeKey("caipAddress", function(val) {
                return _this.onNewAddress(val);
            }),
            (0, $cwWZ7.OptionsController).subscribeKey("isSiweEnabled", function(val) {
                return _this.isSiweEnabled = val;
            })
        ]);
        (0, $cwWZ7.EventsController).sendEvent({
            type: "track",
            event: "MODAL_LOADED"
        });
        return _this;
    }
    (0, $1wc17._)(W3mModal, [
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.unsubscribe.forEach(function(unsubscribe) {
                    return unsubscribe();
                });
                this.onRemoveKeyboardListener();
            }
        },
        {
            key: "render",
            value: function render() {
                return this.open ? (0, $4A6TP.html)($e47a5c346ba22db5$var$_templateObject(), this.onOverlayClick.bind(this), this.shake) : null;
            }
        },
        {
            key: "onOverlayClick",
            value: function onOverlayClick(event) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(event.target === event.currentTarget)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.handleClose()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleClose",
            value: function handleClose() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var isSiweSignScreen, isApproveSignScreen, SIWEController, isUnauthenticated;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                isSiweSignScreen = (0, $cwWZ7.RouterController).state.view === "ConnectingSiwe";
                                isApproveSignScreen = (0, $cwWZ7.RouterController).state.view === "ApproveTransaction";
                                if (!_this.isSiweEnabled) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (parcelRequire("jCIHD"))
                                ];
                            case 1:
                                SIWEController = _state.sent().SIWEController;
                                isUnauthenticated = SIWEController.state.status !== "success";
                                if (isUnauthenticated && (isSiweSignScreen || isApproveSignScreen)) (0, $cwWZ7.ModalController).shake();
                                else (0, $cwWZ7.ModalController).close();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                (0, $cwWZ7.ModalController).close();
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "initializeTheming",
            value: function initializeTheming1() {
                var _ThemeController_state = (0, $cwWZ7.ThemeController).state, themeVariables = _ThemeController_state.themeVariables, themeMode = _ThemeController_state.themeMode;
                var defaultThemeMode = (0, $grHtr.UiHelperUtil).getColorTheme(themeMode);
                (0, $grHtr.initializeTheming)(themeVariables, defaultThemeMode);
            }
        },
        {
            key: "onClose",
            value: function onClose() {
                this.open = false;
                this.classList.remove("open");
                this.onScrollUnlock();
                (0, $cwWZ7.SnackController).hide();
                this.onRemoveKeyboardListener();
            }
        },
        {
            key: "onOpen",
            value: function onOpen() {
                this.open = true;
                this.classList.add("open");
                this.onScrollLock();
                this.onAddKeyboardListener();
            }
        },
        {
            key: "onScrollLock",
            value: function onScrollLock() {
                var styleTag = document.createElement("style");
                styleTag.dataset["w3m"] = $e47a5c346ba22db5$var$SCROLL_LOCK;
                styleTag.textContent = "\n      body {\n        touch-action: none;\n        overflow: hidden;\n        overscroll-behavior: contain;\n      }\n      w3m-modal {\n        pointer-events: auto;\n      }\n    ";
                document.head.appendChild(styleTag);
            }
        },
        {
            key: "onScrollUnlock",
            value: function onScrollUnlock() {
                var styleTag = document.head.querySelector('style[data-w3m="'.concat($e47a5c346ba22db5$var$SCROLL_LOCK, '"]'));
                if (styleTag) styleTag.remove();
            }
        },
        {
            key: "onAddKeyboardListener",
            value: function onAddKeyboardListener() {
                var _this = this;
                var _this_shadowRoot;
                this.abortController = new AbortController();
                var card = (_this_shadowRoot = this.shadowRoot) === null || _this_shadowRoot === void 0 ? void 0 : _this_shadowRoot.querySelector("wui-card");
                card === null || card === void 0 ? void 0 : card.focus();
                window.addEventListener("keydown", function(event) {
                    if (event.key === "Escape") _this.handleClose();
                    else if (event.key === "Tab") {
                        var tagName = event.target.tagName;
                        if (tagName && !tagName.includes("W3M-") && !tagName.includes("WUI-")) card === null || card === void 0 ? void 0 : card.focus();
                    }
                }, this.abortController);
            }
        },
        {
            key: "onRemoveKeyboardListener",
            value: function onRemoveKeyboardListener() {
                var _this_abortController;
                (_this_abortController = this.abortController) === null || _this_abortController === void 0 ? void 0 : _this_abortController.abort();
                this.abortController = undefined;
            }
        },
        {
            key: "onNewAddress",
            value: function onNewAddress(caipAddress) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var previousAddress, newAddress, previousNetworkId, newNetworkId, SIWEController, session, _SIWEController_state__client, _SIWEController_state__client1;
                    return (0, $eha6O.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.connected || _this.loading) return [
                                    2
                                ];
                                previousAddress = (0, $cwWZ7.CoreHelperUtil).getPlainAddress(_this.caipAddress);
                                newAddress = (0, $cwWZ7.CoreHelperUtil).getPlainAddress(caipAddress);
                                previousNetworkId = (0, $cwWZ7.CoreHelperUtil).getNetworkId(_this.caipAddress);
                                newNetworkId = (0, $cwWZ7.CoreHelperUtil).getNetworkId(caipAddress);
                                _this.caipAddress = caipAddress;
                                if (!_this.isSiweEnabled) return [
                                    3,
                                    9
                                ];
                                return [
                                    4,
                                    (parcelRequire("jCIHD"))
                                ];
                            case 1:
                                SIWEController = _state.sent().SIWEController;
                                return [
                                    4,
                                    SIWEController.getSession()
                                ];
                            case 2:
                                session = _state.sent();
                                if (!(session && previousAddress && newAddress && previousAddress !== newAddress)) return [
                                    3,
                                    5
                                ];
                                if (!((_SIWEController_state__client = SIWEController.state._client) === null || _SIWEController_state__client === void 0 ? void 0 : _SIWEController_state__client.options.signOutOnAccountChange)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    SIWEController.signOut()
                                ];
                            case 3:
                                _state.sent();
                                _this.onSiweNavigation();
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                            case 5:
                                if (!(session && previousNetworkId && newNetworkId && previousNetworkId !== newNetworkId)) return [
                                    3,
                                    8
                                ];
                                if (!((_SIWEController_state__client1 = SIWEController.state._client) === null || _SIWEController_state__client1 === void 0 ? void 0 : _SIWEController_state__client1.options.signOutOnNetworkChange)) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    SIWEController.signOut()
                                ];
                            case 6:
                                _state.sent();
                                _this.onSiweNavigation();
                                _state.label = 7;
                            case 7:
                                return [
                                    2
                                ];
                            case 8:
                                _this.onSiweNavigation();
                                _state.label = 9;
                            case 9:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onSiweNavigation",
            value: function onSiweNavigation() {
                if (this.open) (0, $cwWZ7.RouterController).push("ConnectingSiwe");
                else (0, $cwWZ7.ModalController).open({
                    view: "ConnectingSiwe"
                });
            }
        }
    ]);
    return W3mModal;
}((0, $4A6TP.LitElement));
$e47a5c346ba22db5$export$8f54aa55129a8184.styles = (0, $hEpgx.default);
$e47a5c346ba22db5$var$__decorate([
    (0, $kAqXG.state)()
], $e47a5c346ba22db5$export$8f54aa55129a8184.prototype, "open", void 0);
$e47a5c346ba22db5$var$__decorate([
    (0, $kAqXG.state)()
], $e47a5c346ba22db5$export$8f54aa55129a8184.prototype, "caipAddress", void 0);
$e47a5c346ba22db5$var$__decorate([
    (0, $kAqXG.state)()
], $e47a5c346ba22db5$export$8f54aa55129a8184.prototype, "isSiweEnabled", void 0);
$e47a5c346ba22db5$var$__decorate([
    (0, $kAqXG.state)()
], $e47a5c346ba22db5$export$8f54aa55129a8184.prototype, "connected", void 0);
$e47a5c346ba22db5$var$__decorate([
    (0, $kAqXG.state)()
], $e47a5c346ba22db5$export$8f54aa55129a8184.prototype, "loading", void 0);
$e47a5c346ba22db5$var$__decorate([
    (0, $kAqXG.state)()
], $e47a5c346ba22db5$export$8f54aa55129a8184.prototype, "shake", void 0);
$e47a5c346ba22db5$export$8f54aa55129a8184 = $e47a5c346ba22db5$var$__decorate([
    (0, $grHtr.customElement)("w3m-modal")
], $e47a5c346ba22db5$export$8f54aa55129a8184);

});
parcelRegister("hEpgx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd99c55b1cdf67df$export$2e2bcd8739ae039; });

var $j06k0 = parcelRequire("j06k0");

var $4A6TP = parcelRequire("4A6TP");
function $cd99c55b1cdf67df$var$_templateObject() {
    var data = (0, $j06k0._)([
        "\n  :host {\n    z-index: var(--w3m-z-index);\n    display: block;\n    backface-visibility: hidden;\n    will-change: opacity;\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    pointer-events: none;\n    opacity: 0;\n    background-color: var(--wui-cover);\n    transition: opacity 0.2s var(--wui-ease-out-power-2);\n    will-change: opacity;\n  }\n\n  :host(.open) {\n    opacity: 1;\n  }\n\n  wui-card {\n    max-width: var(--w3m-modal-width);\n    width: 100%;\n    position: relative;\n    animation: zoom-in 0.2s var(--wui-ease-out-power-2);\n    animation-fill-mode: backwards;\n    outline: none;\n  }\n\n  wui-card[shake='true'] {\n    animation:\n      zoom-in 0.2s var(--wui-ease-out-power-2),\n      w3m-shake 0.5s var(--wui-ease-out-power-2);\n  }\n\n  wui-flex {\n    overflow-x: hidden;\n    overflow-y: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n  }\n\n  @media (max-height: 700px) and (min-width: 431px) {\n    wui-flex {\n      align-items: flex-start;\n    }\n\n    wui-card {\n      margin: var(--wui-spacing-xxl) 0px;\n    }\n  }\n\n  @media (max-width: 430px) {\n    wui-flex {\n      align-items: flex-end;\n    }\n\n    wui-card {\n      max-width: 100%;\n      border-bottom-left-radius: 0;\n      border-bottom-right-radius: 0;\n      border-bottom: none;\n      animation: slide-in 0.2s var(--wui-ease-out-power-2);\n    }\n\n    wui-card[shake='true'] {\n      animation:\n        slide-in 0.2s var(--wui-ease-out-power-2),\n        w3m-shake 0.5s var(--wui-ease-out-power-2);\n    }\n  }\n\n  @keyframes zoom-in {\n    0% {\n      transform: scale(0.95) translateY(0);\n    }\n    100% {\n      transform: scale(1) translateY(0);\n    }\n  }\n\n  @keyframes slide-in {\n    0% {\n      transform: scale(1) translateY(50px);\n    }\n    100% {\n      transform: scale(1) translateY(0);\n    }\n  }\n\n  @keyframes w3m-shake {\n    0% {\n      transform: scale(1) rotate(0deg);\n    }\n    20% {\n      transform: scale(1) rotate(-1deg);\n    }\n    40% {\n      transform: scale(1) rotate(1.5deg);\n    }\n    60% {\n      transform: scale(1) rotate(-1.5deg);\n    }\n    80% {\n      transform: scale(1) rotate(1deg);\n    }\n    100% {\n      transform: scale(1) rotate(0deg);\n    }\n  }\n\n  @keyframes w3m-view-height {\n    from {\n      height: var(--prev-height);\n    }\n    to {\n      height: var(--new-height);\n    }\n  }\n"
    ]);
    $cd99c55b1cdf67df$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $cd99c55b1cdf67df$export$2e2bcd8739ae039 = (0, $4A6TP.css)($cd99c55b1cdf67df$var$_templateObject());

});

parcelRegister("jCIHD", function(module, exports) {


module.exports = (parcelRequire("eg86f"))((parcelRequire("bRvn3")).resolve("d2Ske")).then(function() {
    return parcelRequire("8ecTx");
});

});



})();
//# sourceMappingURL=w3m-modal.d2ce20b9.js.map
